<template>
  <transition name="fade">
    <div class="modal-mask" v-if="opened">
      <div class="modal-wrapper" @click.self="() => closeModal()">
        <div class="modal-container">
          <terms-of-service-contents
            v-if="name === `terms-of-service`"
            @close="() => closeModal()"
          />
          <p class="close-button" @click="() => closeModal()">
            x 閉じる
          </p>
        </div>
      </div>
    </div>
  </transition>
</template>

<script setup>
import { computed } from 'vue';
import TermsOfServiceContents from './content/TermsOfServiceContents';

const emit = defineEmits(['close']);

const props = defineProps({
  name: {
    type: String,
    required: true
  }
});

const opened = computed(() => {
  return props.name !== '';
});

const closeModal = () => {
  emit('close');
};
</script>
<style>
.modal-mask {
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  transition: opacity 0.3s ease;
  position: fixed;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
  overflow: hidden;
  position: fixed;
  width: 100%;
  height: 100%;
}

.modal-container {
  width: 80%;
  height: 100%;
  margin: 2vh auto;
  height: 90vh;
  padding: 20px 30px;
  overflow: scroll;
  background-color: #fff;
  border-radius: 12px;
  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-container .modal-header {
  padding: 10px 10px 5px;
  background: #006;
  position: relative;
}
.modal-container .modal-header h2 {
  color: white;
  font-size: 24px;
  font-weight: normal;
  text-align: left;
  margin: 0;
}
.modal-container .modal-header span {
  color: white;
  font-size: 24px;
  font-weight: normal;
  position: absolute;
  top: 3px;
  right: 8px;
}
.modal-container .modal-header span:hover {
  opacity: 0.9;
  cursor: pointer;
}
.modal-container section {
  margin: 25px 5px;
}
.modal-container section p,
.modal-container section li {
  line-height: 160%;
  font-size: 14px;
  margin: 6px 0;
}
.modal-container section br {
  line-height: 230%;
}
.modal-container h3 {
  font-size: 20px;
  padding-bottom: 5px;
  border-bottom: 1px solid #d6d6d6;
  margin: 30px 0 5px 0;
}
.modal-container h4 {
  font-size: 16px;
  margin: 30px 0 10px 0;
}
.modal-container ol {
  list-style-type: decimal;
  padding-left: 18px;
}

.modal-container ol {
  list-style-type: decimal;
  padding-left: 18px;
}
.modal-container a {
  color: #0e1bbb !important;
  text-decoration: underline !important;
}

.modal-container .close-button {
  margin-bottom: 5%;
  cursor: pointer;
  text-align: center;
  color: #fff;
  background-color: #777;
  border-radius: 4px;
  line-height: 32px;
  font-size: 18px;
}
.commit-histories li {
  margin: 3px 0;
}
.modal-container .close-button:hover {
  opacity: 0.6;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.fade-enter-active,
.fade-leave-active {
  transition: 0.2s opacity ease-out;
}
@media only screen and (max-width: 640px) {
  .modal-container {
    width: 85%;
    padding: 20px 15px;
  }
}
</style>
